import React, { useState, useEffect, useRef } from 'react';
import signinimage from '../asserts/img/logo.png';
import { toast } from 'react-toastify';
import Button from '../components/Button';
import { useDispatch, useSelector } from 'react-redux';
import { signinUserFront } from '../slice/userSlice';
import { useNavigate } from 'react-router-dom';

function UserLogin() {
    const [email, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [rememberMe, setRememberMe] = useState(false);
    const isFreshLogin = useRef(false);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { loading, error, response, message } = useSelector(state => state.user);

    useEffect(() => {
        if (response && response?.data?.access_token) {
            const hasStoredToken = !!localStorage.getItem('userToken') || !!sessionStorage.getItem('userToken');
            if (isFreshLogin.current) {
                if (rememberMe) {
                    localStorage.setItem('userToken', response.data.access_token); 
                } else {
                    sessionStorage.setItem('userToken', response.data.access_token); 
                }
                isFreshLogin.current = false;
                navigate('/dashboard');
            } else if (hasStoredToken) {
                navigate('/dashboard');
            }
            // else: stale persisted response with no active session -> stay on login page
        } else if (error) {
            toast(message || 'Something went wrong');
        }
    }, [response, error, navigate, message, rememberMe, dispatch]);

    const loginHandler = async (e) => {
        e.preventDefault();
        isFreshLogin.current = true;
        dispatch(signinUserFront({ email, password }));
    };

    const handleRememberMeChange = (e) => {
        setRememberMe(e.target.checked);
    };

    return (
        <section className="sign-in">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-xl-8 col-lg-10 col-md-12">
                        <div className="card o-hidden border-0 shadow-lg my-5">
                            <div className="card-body p-0">
                                <div className="row mt-5">
                                    <div className="col-lg-6 d-none d-lg-block text-center">
                                        <img src={signinimage} alt='login ' className='img-fluid loginimg'/>
                                    </div>
                                    <div className="col-lg-6">
                                        <div className="p-5">
                                            <div className="text-center">
                                                <h1 className="h4 mb-4"><strong>Welcome User</strong></h1>
                                            </div>
                                            <form className="user" onSubmit={loginHandler}>
                                                <div className="form-group">
                                                    <input 
                                                        type="email" 
                                                        className="form-control form-control-user"
                                                        placeholder="Enter Email Address..."  
                                                        onChange={(e) => setUsername(e.target.value)}
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <input 
                                                        type="password" 
                                                        className="form-control form-control-user"
                                                        placeholder="Password" 
                                                        onChange={(e) => setPassword(e.target.value)}
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <div className="custom-control custom-checkbox small">
                                                        <input 
                                                            type="checkbox" 
                                                            className="custom-control-input" 
                                                            id="customCheck" 
                                                            checked={rememberMe}
                                                            onChange={handleRememberMeChange}
                                                        />
                                                        <label 
                                                            className="custom-control-label" 
                                                            htmlFor="customCheck"
                                                        >
                                                            Remember Me
                                                        </label>
                                                    </div>
                                                </div>
                                                <Button 
                                                    onclickfun={loginHandler} 
                                                    disabled={loading} 
                                                    className="btn addbtn btn-user btn-block" 
                                                    text="Login"
                                                />
                                                <hr />
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default UserLogin;
